import React, { Fragment, useState, forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import style from './VerifyButton.scss';

const VerifyButton = forwardRef(({
  onClick,
  isVerified = false,
  isLoading = true,
}, ref) => {
  const [buttonHovered, setButtonHovered] = useState(false);

  const handleMouseEnter = () => {
    setButtonHovered(true);
  };

  const handleMouseLeave = () => {
    setButtonHovered(false);
  };

  return isVerified ? (
    <div
      className={cn(style['smarty-tag-check'], style['smarty-tag-green'])}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={ref}
    >
      ✓
      <span className={style.verifyText}>
        {buttonHovered ? 'Undo' : 'Verified'}
      </span>
    </div>
  ) : (
    <Fragment>
      {isLoading && (
        <div className={style['smarty-ui']}>
          <div
            title="Loading..."
            className={cn(style['smarty-dots'], style['smarty-addr-29102'])}
          />
        </div>
      )}
      <div ref={ref} className={cn(style['smarty-tag-check'])} onClick={onClick}>
        ✓<span className={style.verifyText}>Verify Address</span>
      </div>
    </Fragment>
  );
});

VerifyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isVerified: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default VerifyButton;
